import { prop } from 'ramda';

import { themesAdapter } from '@/adapters';

export const themesEntitySelector = themesAdapter.getSelectors<RootState>(prop('themes'));
